import { writable } from 'svelte/store';
import { CALL_STATE_CONSTANTS } from '../services/utils';
let state = {
    callSession: null,
    peer: '',
    peerInitials: null,
    peerName: null,
    state: CALL_STATE_CONSTANTS.IDLE,
    ua: null,
    duration: 0,
    notes: '',
    timerInterval: null,
    credentials: {
        domain: '',
        host: '',
        port: '',
        protocol: '',
        username: '',
        password: ''
    },
    sessions: [],
    microphone: true,
    hold: false,
    callActive: false,
    takeNote: false,
    sipConnected: false,
    minimize: false,
    notification: ''
};
let call = () => {
    const { subscribe, set, update } = writable(state);
    return {
        subscribe,
        update: (data) => update((store) => (Object.assign(Object.assign({}, store), data))),
        setCredentials: (credentials) => update((store) => (Object.assign(Object.assign({}, store), { credentials }))),
        reset: () => update(() => (Object.assign({}, state))),
    };
};
export default call();
